import { Component, Input, OnInit } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { ValidationHeaderComponent } from '../validation-header/validation-header.component';
import { ValidatePrescriberMatchFormComponent } from '../validate-prescriber-match-form/validate-prescriber-match-form.component';

@Component({
    selector: 'app-validate-prescriber-match',
    templateUrl: './validate-prescriber-match.component.html',
    styleUrls: ['./validate-prescriber-match.component.scss'],
    imports: [ValidationHeaderComponent, ValidatePrescriberMatchFormComponent]
})
export class ValidatePrescriberMatchComponent implements OnInit {
  collapsed = false;

  @Input() patientAttachment: PatientAttachment;

  constructor() {}

  ngOnInit() {}

  onCollapseChange(collapsed) {
    this.collapsed = collapsed;
  }

  collapse() {
    this.collapsed = true;
  }

  expand() {
    this.collapsed = false;
  }
}
